export default __webpack_public_path__ + "b37bfd02954fe1238f54d03095544a93.png";